<template>
  <el-form :inline="true" class="demo-form-inline">
        <el-form-item label="级别：">
            <el-select style="width: 130px;" v-model="formInline.level" filterable placeholder="请选择">
                <el-option
                v-for="item in levelOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
                </el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="关键字：">
            <el-input v-model="formInline.keyword" placeholder="请输入组织名称或描述"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="search()">搜索</el-button>
          <!-- <el-button type="primary" @click="getList()">刷新</el-button> -->
          <!-- <el-button type="primary">导出</el-button> -->
        </el-form-item>
    </el-form>
    <!-- <div class="search_nav">
        <el-button type="primary" @click="search()">搜索</el-button>
        <el-button type="primary" @click="getList()">刷新</el-button>
        <el-button type="primary">导出</el-button>
    </div> -->
    <el-table class="table_wrapper" :data="tableData" :header-cell-style="{'text-align':'left'}" :cell-style="{'text-align':'left'}">
      <!-- <el-table-column label="排序" width="80">
        <template #default="scope">
          <div>
            <span>{{scope.row.sort}}</span>
          </div>
        </template>
      </el-table-column> -->
      <el-table-column label="组织名称" width="260" show-overflow-tooltip>
        <template #default="scope">
          <div>
            <span>{{ scope.row.name }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="级别" width="150">
        <template #default="scope">
          <div>
            <span>{{ levelFilter(scope.row.level) }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="部门归属" show-overflow-tooltip>
        <template #default="scope">
          <div>
            <span>{{ scope.row.parentName || '--' }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="描述" show-overflow-tooltip>
        <template #default="scope">
          <div>
            <span>{{ scope.row.description || '--' }}</span>
          </div>
        </template>
      </el-table-column>
      
      <el-table-column label="操作" width="240">
        <template #default="scope">
          <el-button v-if="scope.row.level < 4" type="success" size="small" @click="showAdd(scope.$index, scope.row)">
            添加组织
          </el-button>
          <el-button size="small" @click="handleEdit(scope.$index, scope.row)">
            编辑
          </el-button>
          <el-button
            size="small"
            type="danger"
            @click="handleDelete(scope.$index, scope.row)"
          >
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <Pagination
        v-model:current-page="currentPage"
        v-model:page-size="pageSize"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
    />

    <!-- 对话框--新建、编辑组织 -->
    <el-dialog v-model="dialogFormVisible" :title="dialogTitle" width="500" :close-on-click-modal="false" @closed="$refs.addFormRef?.clearValidate()">
        <el-form ref="addFormRef" label-position="right" label-width="auto" :model="addInfo" :rules="addRules">
        <el-form-item label="组织名称" prop="name">
          <el-input v-model="addInfo.name" autocomplete="off" />
        </el-form-item>
        <el-form-item label="级别">
            <el-select v-model="selectedRoles" placeholder="请选择">
              <el-option
                  v-for="item in rolesList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="排序" prop="sort">
            <el-input v-model="addInfo.sort" autocomplete="off" />
        </el-form-item>
        
        <el-form-item label="描述">
            <el-input v-model="addInfo.description" autocomplete="off" />
        </el-form-item>
        </el-form>
        <template #footer>
        <div class="dialog-footer">
            <el-button @click="dialogFormVisible = false">取消</el-button>
            <el-button type="primary" @click="saveInfo()">确定</el-button>
        </div>
        </template>
    </el-dialog>

    <!-- 对话框--删除 -->
    <el-dialog
      v-model="centerDialogVisible"
      title="提示"
      width="500"
      align-center
    >
      <span>确定删除该组织？</span>
      <template #footer>
        <div class="dialog-footer">
          <el-button @click="centerDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="deleteUser()">确定</el-button>
        </div>
      </template>
    </el-dialog>

  </template>
  
  <script>
  import { required, isNumber, noSpecialChar } from '@/utils/validators';
  export default {
  name:'OrganManage',
  data() {
    return {
      formInline:{
        keyword:'',
        level:'',
      },
      levelOptions:[
        {
          label:'全部',
          value:''
        },
        {
          label:'一级组织',
          value:1
        },
        {
          label:'二级组织',
          value:2
        },
        {
          label:'三级组织',
          value:3
        },
        {
          label:'四级组织',
          value:4
        }
      ],
      selectedRoles: [],
      rolesList:[],
      allOrgList: [
        {
          label:'二级组织',
          value:2
        },
        {
          label:'三级组织',
          value:3
        },
        {
          label:'四级组织',
          value:4
        },
      ],
      isUpdate:false,
      dialogTitle:'添加组织',
      dialogFormVisible:false,
      centerDialogVisible:false,
      currt_id:'', //当前操作id
      currtParentId:'', //当前操作组织父级id
      currentLevel:1, //当前操作组织级别
      tableData:[],
      addFormRef: null,
      addRules: {
        name: [required('请输入组织名称'), noSpecialChar('组织名称不能包含特殊字符')],
        sort: [isNumber('排序只能输入数字')],
      },
      addInfo:{
        name: '',
        level:'',
        parentId:'',
        sort:'',
        description:'',
      },
      total: 0, //总条数
      currentPage: 1, //当前页
      pageSize: 10, //每页显示条数
    }
  },
  components: {
    
  },
  computed: {
    filteredMessage() {
      // 这里可以实现类似过滤器的转换逻辑
    }
  },
  beforeCreate(){
    
  },
  created(){
    
  },
  mounted(){
    this.getList();
  },
  methods:{
    handleSizeChange (val) { //每页显示条数
        this.pageSize = val;
        this.currentPage = 1;
        this.getList();
    },
    handleCurrentChange(val) { //当前页
        this.currentPage = val;
        this.getList(); //获取列表
    },
    search(){
      //搜索
      let that = this;
      let param = {};
      param.page = this.currentPage;
      param.pageSize = this.pageSize;
      if(that.formInline.keyword){
        param.keyword = that.formInline.keyword;
      }
      if(that.formInline.level){
        param.level = that.formInline.level;
      }
      that.$axios.post(that.$store.state.platformApi+"org/page",JSON.stringify(param)).then(result => {
        if(result.code==200){
          that.tableData = result.data.records;
          that.total = result.data.total;
        }
      })
    },
    getList(){
      //获取列表
      let that = this;
      let param = {};
      param.page = this.currentPage;
      param.pageSize = this.pageSize;
      that.$axios.post(that.$store.state.platformApi+"org/page",JSON.stringify(param)).then(result => {
        if(result.code==200){
          that.tableData = result.data.records;
          that.total = result.data.total;
        }
      })
    },
    saveInfo(){
      //保存
      let that = this;
      // 表单校验
      this.$refs.addFormRef.validate((valid) => {
        if (!valid) return;
        let param = {};
        if(that.isUpdate){
          //编辑
          param.id = that.addInfo.id;
        }
        param.name = that.addInfo.name;
        param.level = that.selectedRoles;
        if(that.currentLevel == param.level){
          param.parentId = that.currtParentId;
        }else{
          param.parentId = that.currt_id;
        }
        param.sort = that.addInfo.sort;
        param.description = that.addInfo.description;
        var url = that.$store.state.platformApi+"org/edit";
        that.$axios.post(url,JSON.stringify(param)).then(result => {
          if(result.code==200){
            // 保存成功
            that.dialogFormVisible = false;
            that.getList();
          }
        })
      });
    },
    showAdd(index,row){
      //打开添加组织弹窗
        this.isUpdate = false;
        this.dialogTitle = '添加组织';
        this.currt_id = row.id;
        this.currentLevel = row.level;
        this.currtParentId = row.parentId;
        this.selectedRoles = [];
        //限制添加部门级别，只能是下一级
        this.addInfo.parentId = row.id;
        this.rolesList = this.allOrgList.filter(item => (item.value == row.level+1));
        this.addInfo = Object.fromEntries(
          Object.keys(this.addInfo).map(key => [key, ''])
        );
        this.dialogFormVisible = true;
    },
    handleEdit(index,row){
      //打开编辑
      let that = this;
      that.dialogTitle = '编辑组织';
      that.isUpdate = true;
      that.dialogFormVisible = true;
      let param = {};
      param.id = row.id;
      that.$axios.post(that.$store.state.platformApi+"org/view",JSON.stringify(param)).then(result => {
        if(result.code==200){
          that.addInfo = result.data;
          that.selectedRoles = result.data.roleIds;
        }
      })
    },
    deleteUser(){
      //删除组织
      let that = this;
      that.$axios.post(that.$store.state.platformApi+"org/del/"+that.currt_id).then(result => {
        // console.log(result);
        if(result.code==200){
          that.centerDialogVisible = false;
          that.getList();
          ElMessage({
            message: '已删除组织',
            type: 'success',
          })
        }
      })
    },
    handleDelete(index,row){
        //删除弹窗
      this.centerDialogVisible = true;
      this.currt_id = row.id;
    },
    levelFilter(value) {
      //过滤函数
      switch (value) {
        case 1:
          return '一级组织';
        case 2:
          return '二级组织';
        case 3:
          return '三级组织';
        case 4:
          return '四级组织';
        default:
          return value;
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.search_nav{
    width: 100%;
    height: 60px;
}
</style>